import * as React from 'react';
import { AuthProvider } from '@sdk/authentication/AuthContext';
import type { AuthUserType } from '@sdk/authentication/types/AuthUserType';

import { AccountActivityScreen } from '../AccountActivityScreen';

type Props = {
  user: AuthUserType;
};
const AccountActivityWithContext: React.FC<React.PropsWithChildren<Props>> = ({ user }) => {
  return (
    <AuthProvider currentUser={user}>
      <AccountActivityScreen />
    </AuthProvider>
  );
};

export default {
  ReactComponent: AccountActivityWithContext,
  bindings: {
    user: '<',
  },
};
